/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { useI18n } from "hooks/i18n/i18n";

import type { FC } from "react";

export const AddToCartButton: FC<{
  isDarkModeEnabled: boolean;
  onClick: () => void;
}> = ({ isDarkModeEnabled, onClick }) => {
  const { t } = useI18n();
  return (
    <button
      type={"button"}
      css={css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 100%;
        padding: 6px 12px;
        text-align: center;
        background-color: ${isDarkModeEnabled ? "#000" : "#fff"};
        border: 1px solid ${isDarkModeEnabled ? "#fff" : "#000"};
        border-radius: 6px;
        cursor: pointer;
        svg {
          fill: ${isDarkModeEnabled ? "#fff" : "#000"};
          width: 16px;
          height: 16px;
        }
      `}
      onClick={onClick}
    >
      <ShoppingCartIcon />
      <Box
        component={"span"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
        fontSize={"14px"}
        fontWeight={"700"}
      >
        {t("streaming.commerceGoodsList.cartIn")}
      </Box>
    </button>
  );
};
